import { ClaimPropertyStatusEnum } from '../../../../../enums/claim-property-status.enum';
import { ClaimProductTypeEnum } from '../../../enums/ClaimProductType.enum';
import { OtherProductClaimInitialValuesType } from './types';

export const getOtherProductClaimInitialValues = (
  productType: ClaimProductTypeEnum,
  estateId = ''
): OtherProductClaimInitialValuesType => ({
  productType,
  claimEstate: {
    status: 'CREATED',
    observations: '',
    responsibleId: null,
    estateResponsibleId: null,
    estateId,
    insurerId: '',
    createdBy: '',
    policyNumber: null,
    processNumber: null,
    claimCode: null,
    notificationEmails: [''],
    propertyPublicId: undefined,
    productType,
    eventDate: null,
    eventTime: '',
    eventDescription: '',
    coverages: [],
    insuranceBroker: '',
    insuranceStatus: '',
    insuranceExpirationDate: null
  },
  claimProperty: {
    zipCode: '',
    country: 'Brasil',
    city: '',
    complement: '',
    district: '',
    number: '',
    state: '',
    propertyCode: '',
    status: ClaimPropertyStatusEnum.occupied,
    street: '',
    deliveryKeysDate: undefined
  },
  claimTenant: {
    document: '',
    fullName: '',
    email: '',
    cellphone: ''
  },
  claimCondominium: {
    document: '',
    legalName: '',
    type: '',
    units: '',
    assessor: '',
    email: '',
    phone: '',
    syndic: {
      name: '',
      document: '',
      rg: '',
      birthDate: null,
      email: '',
      phone: ''
    }
  },
  claimFiles: []
});
